import { TransferApi } from 'api/endpoints/Transfer';
import { procurementApi } from 'api/endpoints/Procurement';
import { getTenantFromToken } from 'utils/routeUtils';
import { receptionApi } from 'api/endpoints/Reception';
import { processApi } from 'api/endpoints/Process';
import { processedItemApi } from 'api/endpoints/ProcessedItem';
import { gradeItemApi } from 'api/endpoints/GradeItem';
import { processedStageApi } from 'api/endpoints/ProcessedStage';
import { cropItemApi } from 'api/endpoints/Crop';
import { cropVarietyItemApi } from 'api/endpoints/CropVariety';
import { traceabilityUserApi } from 'api/endpoints/TraceabilityUser';
import { moduleApi } from 'api/endpoints/Module';
import { SalesOrderApi } from 'api/endpoints/SalesOrder';

const formProps = type => {
  const config = {
    transfer: {
      title: 'Transfer Items',
      fetchFormApi: TransferApi.transferForm,
      fetchEditFormApi: TransferApi.transferEditForm,
      createApi: TransferApi.createTransfer,
      updateApi: TransferApi.updateTransfer,
      reportPath: `/transferReport`
    },
    procurement: {
      title: 'Procurement',
      fetchFormApi: procurementApi.procurementForm,
      fetchEditFormApi: procurementApi.editProcurementForm,
      createApi: procurementApi.createProcurement,
      updateApi: procurementApi.updateProcurement,
      reportPath: `/procurementReport`
    },
    reception: {
      title: 'Reception',
      fetchFormApi: receptionApi.receptionForm,
      fetchEditFormApi: receptionApi.editReceptionForm,
      createApi: receptionApi.createReception,
      updateApi: receptionApi.updateReception,
      reportPath: `/receptionReport`
    },
    process: {
      title: 'Process',
      fetchFormApi: processApi.processForm,
      fetchEditFormApi: processApi.editProcessForm,
      createApi: processApi.createProcess,
      updateApi: processApi.updateProcess,
      reportPath: `/processReport`
    },
    processedItem: {
      title: 'Processed Item',
      fetchFormApi: processedItemApi.processedItemForm,
      fetchEditFormApi: processedItemApi.editProcessedItemForm,
      createApi: processedItemApi.createProcessedItem,
      updateApi: processedItemApi.updateProcessedItem,
      reportPath: `/processedItemReport`
    },
    processedStage: {
      title: 'Processed Stage',
      fetchFormApi: processedStageApi.processedStageForm,
      fetchEditFormApi: processedStageApi.editProcessedStageForm,
      createApi: processedStageApi.createProcessedStage,
      updateApi: processedStageApi.updateProcessedStage,
      reportPath: `/processedStageReport`
    },
    gradeItem: {
      title: 'Grade Item',
      fetchFormApi: gradeItemApi.gradeItemForm,
      fetchEditFormApi: gradeItemApi.editGradeItemForm,
      createApi: gradeItemApi.createGradeItem,
      updateApi: gradeItemApi.updateGradeItem,
      reportPath: `/gradeItemReport`
    },
    cropItem: {
      title: 'Crop Item',
      fetchFormApi: cropItemApi.cropItemForm,
      fetchEditFormApi: cropItemApi.editCropItemForm,
      createApi: cropItemApi.createCropItem,
      updateApi: cropItemApi.updateCropItem,
      reportPath: `/cropItemReport`
    },
    cropVarietyItem: {
      title: 'Crop Variety Item',
      fetchFormApi: cropVarietyItemApi.cropItemVarietyForm,
      fetchEditFormApi: cropVarietyItemApi.editCropVarietyItemForm,
      createApi: cropVarietyItemApi.createCropVarietyItem,
      updateApi: cropVarietyItemApi.updateCropVarietyItem,
      reportPath: `/cropVarietyItemReport`
    },
    traceabilityUser: {
      title: 'Traceability User',
      fetchFormApi: traceabilityUserApi.traceabilityUserForm,
      fetchEditFormApi: traceabilityUserApi.editTraceabilityUserForm,
      createApi: traceabilityUserApi.createTraceabilityUser,
      updateApi: traceabilityUserApi.updateTraceabilityUser,
      reportPath: `/traceabilityUserReport`
    },
    module: {
      title: 'Module',
      fetchFormApi: moduleApi.moduleForm,
      fetchEditFormApi: moduleApi.editModuleForm,
      createApi: moduleApi.createModule,
      updateApi: moduleApi.updateModule,
      reportPath: `/moduleReport`
    },
    salesOrder: {
      title: 'Sales Order',
      fetchFormApi: SalesOrderApi.salesOrderForm,
      fetchEditFormApi: SalesOrderApi.editSalesOrderForm,
      createApi: SalesOrderApi.createSalesOrder,
      updateApi: SalesOrderApi.updateSalesOrder,
      reportPath: `/salesOrderReport`
    }
  };
  return config[type] || {};
};

export default formProps;
